import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { noop } from 'rxjs';
import { BaseFacade } from './base-facade.model';
import { DummyFeatureSelector } from './dummy-feature.selector';

/* eslint-disable @angular-eslint/prefer-inject */
@Injectable({
  providedIn: 'root'
})
export class DummyFacade extends BaseFacade<never, never, never> {
  constructor(
    protected override store: Store,
    protected override selector: DummyFeatureSelector
  ) {
    super(store, selector);
  }

  getAll() {
    noop();
  }

  setFilters() {
    noop();
  }
}
